/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createActionsHook,
	createHook,
	type BoundActions,
	type HookActionsFunction,
	type HookFunction,
} from '@atlassian/react-sweet-state';
import Store from '../store.tsx';
import type { Actions } from '../actions/page-events/index.tsx';
import type { State } from '../types.tsx';

export const useSpaState: HookFunction<State, BoundActions<State, Actions>, void> = createHook(
	Store,
);

export const useSpaStateActions: HookActionsFunction<BoundActions<State, Actions>> =
	createActionsHook(Store);
